import { render, staticRenderFns } from "./TableEditor.vue?vue&type=template&id=47c12510&scoped=true"
import script from "./TableEditor.vue?vue&type=script&lang=js"
export * from "./TableEditor.vue?vue&type=script&lang=js"
import style0 from "./TableEditor.vue?vue&type=style&index=0&id=47c12510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c12510",
  null
  
)

export default component.exports